import './CurrentUserAvatar.scss';
import React from 'react';
import { SonarUser } from '@ui/SonarUser';
import { useCurrentUser } from '@hooks';

export interface CurrentUserAvatarProps {
	large?: boolean;
}

export const CurrentUserAvatar: React.FC<CurrentUserAvatarProps> = (props) => {
	const user = useCurrentUser();

	if (!user) {
		return null;
	}

	return <SonarUser
		{ ...props }
		className='current-user-avatar'
		userId={ user.id }
		withFullName={ false } />;
};
